import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form, message } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
// icons
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import SaveReportForm from 'pages/Components/reportForm';
import { SearchModel } from 'pages/model';
import { useTranslation } from 'react-i18next';
import { CommonModel } from 'services/Main/common_services';
import { BCTaiTroModel } from 'services/Main/marketingCampaign_services';
import { commonPresenter, commonStore, marketingCampaignPresenter, marketingCampaignStore, uiStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT, SYSTEM_TITLE } from 'utils/constants';
import { debounce } from 'utils/debounce';
import { formatNumber } from 'utils/formatHelper';
import { getPlantCode } from 'utils/localStorageHelper';
import { useResizableColumns } from 'utils/reportHelper';
import { AiOutlineDownload } from 'react-icons/ai';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';
import { useWatch } from 'antd/es/form/Form';

const { RangePicker } = DatePicker;


// BÁO CÁO DANH SÁCH TÀI TRỢ - QUÀ TẶNG KHÁCH HÀNG =================================================================
const createPresentReport = () => {
  return observer(() => {
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.present-report') + ' - ' + SYSTEM_TITLE;

    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });
    const [form] = Form.useForm();

    // ==================================== STATE ===================================================
    // -----DANH SÁCH COMMON ----------------------------------------------
    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // Nhân viên kinh doanh
    const [listPersonInCharge, setListPersonInCharge] = useState<CommonModel[]>([]);
    // Nhân viên admin
    const [listNVAdmin, setListNVAdmin] = useState<CommonModel[]>([]);
    // Khu vực
    const [listRegion, setListRegion] = useState<CommonModel[]>([]);
    // Loại Tài trợ
    const [sponsType, setSponstype] = useState<CommonModel[]>([]);
    // Tỉnh thành phố
    const [listTinh, setListTinh] = useState<CommonModel[]>([]);
    //   quận huyện
    const [listQuanHuyen, setListQuanHuyen] = useState<CommonModel[]>([]);
    //   phòng ban
    const [listDepartment, setListDepartment] = useState<CommonModel[]>([]);
    // Khách hàng
    const [listCustomer, setListCustomer] = useState<CommonModel[]>([]);

    const defaultColumn: ProColumns<BCTaiTroModel>[] = [
      // stt
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 60,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Mã khách hàng
      {
        title: t('marketing.ma-kh'),
        dataIndex: 'profileCode',
        key: 'profileCode',
        width: 90,
        fixed: 'left',
      },
      // mã SAP khách hàng
      {
        title: t('marketing.ma-sap-kh'),
        dataIndex: 'profileForeignCode',
        key: 'profileForeignCode',
        width: 90,
        fixed: 'left',
      },
      // tên khách hàng
      {
        title: t('marketing.ten-kh'),
        dataIndex: 'profileName',
        key: 'profileName',
        width: 250,
        fixed: 'left',
      },
      // Nhóm khách hàng
      {
        title: t('marketing.nhom-kh'),
        dataIndex: 'customerGroupName',
        key: 'customerGroupName',
        width: 150,
      },
      // Nhân viên kinh doanh
      {
        title: t('marketing.nv-kd'),
        dataIndex: 'personInCharge',
        key: 'personInCharge',
        width: 180,
      },
      // Phòng ban
      {
        title: t('marketing.phong-ban'),
        dataIndex: 'department',
        key: 'department',
        width: 180,
      },
      // Loại
      {
        title: t('marketing.loai'),
        dataIndex: 'type',
        key: 'type',
        width: 100,
      },
      // Nội dung tài trợ / quà tặng
      {
        title: t('marketing.noi-dung'),
        dataIndex: 'description',
        key: 'description',
        width: 200,
      },
      // Giá trị tài trợ
      {
        title: t('marketing.gia-tri'),
        dataIndex: 'value',
        key: 'value',
        width: 150,
        onCell: (_, index) => ({
          className: 'text-right',
        }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : text),
      },
      // Thời điểm tài trợ
      {
        title: t('marketing.thoi-diem'),
        dataIndex: 'time',
        key: 'time',
        width: 150,
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY',
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
    ];
    //--- DATA TABLE ------------------------------------------------------------
    // data table báo cáo
    const [dataTable, setDataTable] = useState<BCTaiTroModel[]>([]);
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
      companyCode: getPlantCode(),
      fromTime: undefined,
      toTime: undefined,
    });

    // Loading
    const [exportLoading, setExportLoading] = useState(false);
    const [isSearch, setIsSearch] = useState(false);
    const [disabledPickDate, setDisabledPickDate] = useState(false);

    const [columns, setColumns] = useState<ProColumns<BCTaiTroModel>[]>(defaultColumn);

    const phongBan = useWatch('department', form)

    // ======================================================== function =================================================================
    // ----CÁC HÀM LẤY DATA -------------------------------------------------------------------
    // Lấy danh sách common date
    const getListCommonDate = async () => {
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
    };

    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        form.setFieldValue('pickDate', [dayjs(commonStore.commonDate.fromDate), dayjs(commonStore.commonDate.toDate)]);
      } else {
        form.setFieldValue('pickDate', undefined);
      }
    };

    // Lấy danh sách nhân viên kinh doanh
    const getListPersonInCharge = async (key?: string, type?: 'NVKD' | 'NVADMIN') => {
      await commonPresenter.getListPersonInCharge(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        switch (type) {
          case 'NVADMIN':
            setListNVAdmin(commonStore.commonRespone.data);
            break;
          case 'NVKD':
            setListPersonInCharge(commonStore.commonRespone.data);
            break;
          default:
            setListNVAdmin(commonStore.commonRespone.data);
            setListPersonInCharge(commonStore.commonRespone.data);
            break;
        }
      }
    };
    const searchPersonInCharge = debounce(getListPersonInCharge, 500);

    // lấy danh sách khu vực
    const getListRegion = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'SaleOffice');
      if (commonStore.commonRespone.isSuccess) {
        setListRegion(commonStore.commonRespone.data);
      }
    };
    // lấy danh sách loại tài trợ
    const getListSponsType = async () => {
      await commonPresenter.getCommonDataByKey(commonStore, 'CustomerSponsType');
      if (commonStore.commonRespone.isSuccess) {
        setSponstype(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách Tỉnh / thành phố
    const getListTinhThanhPho = async (area?: string) => {
      await commonPresenter.getListProvince(commonStore, area);
      if (commonStore.commonRespone.isSuccess) {
        setListTinh(commonStore.commonRespone.data);
      }
    };
    // Lấy danh sách quận huyện
    const getListQuanHuyen = async (thanhPho: string[], key?: string) => {
      await commonPresenter.getListDistrict(commonStore, thanhPho, key);
      if (commonStore.commonRespone.isSuccess) {
        setListQuanHuyen(commonStore.commonRespone.data);
      }
    };

    //Danh sách phòng ban
    const getListDepartment = async (key?: string) => {
      await commonPresenter.getListDepartment(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListDepartment(commonStore.commonRespone.data);
      }
    };

    const searchDepartment = debounce(getListDepartment, 500);

    //Danh sách khách hàng
    const getListCustomer = async (key?: string) => {
      await commonPresenter.getListCustomer(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListCustomer(commonStore.commonRespone.data);
      }
    };

    const searchCustomer = debounce(getListCustomer, 500);

    const getDataTable = async (data: SearchModel) => {
      await marketingCampaignPresenter.getDataDSTTQTKH(marketingCampaignStore, { ...data, lang: uiStore.language });
      if (marketingCampaignStore.baocaoQuaTangKH.isSuccess) {
        const dataRow = cloneDeep(marketingCampaignStore.baocaoQuaTangKH.data);
        setDataTable(dataRow);
        return dataRow;
      } else {
        message.error(marketingCampaignStore.baocaoQuaTangKH.message);
        return [];
      }
    };

    useEffect(() => {
      (async () => {
        getListCustomer();
        getListRegion();
        getListCommonDate();
        getListPersonInCharge();
        getListTinhThanhPho();
        getListDepartment();
        getListSponsType();
      })();
    }, []);

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };
    // hidden modal (Add)


    // ===============================================================================================================
    // LOAD LẠI DATA SELECT
    useEffect(() => {
      if (phongBan) {
        searchDepartment()
      }
    }, [phongBan])

    // ============================================LƯU MẪU BÁO CÁO =========================================

    const tableRef = useRef<ActionType>();
    const constDataName = 'BCDSTTQTKH';
    const {
      isResizablePresent,
      setIsResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      handleResize,
    } = useResizableColumns<BCTaiTroModel>(columns, setColumns, constDataName);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.present-report'),
          },
        ]}
        extras={
          <>
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<BCTaiTroModel>
            className="[&_.ant-table-thead_th]:!text-center"
            bordered
            columns={columns}
            handleResize={handleResize}
            isResizablePresent={isResizablePresent}
            resizableColumnSelect={resizableColumnSelect}
            dataSource={dataTable}
            actionRef={tableRef}
            rowKey="stt"
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: marketingCampaignStore.baocaoQuaTangKH.paging?.totalCount,
            }}
            request={async (params = {}, sort, filter) => {
              if (isSearch) {
                const data = await getDataTable({
                  ...dataPaging,
                  paging: {
                    ...dataPaging.paging,
                    orderBy:
                      Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    orderByDesc:
                      Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  },
                });
                console.log(data);

                if (Object.values(sort).length) {
                  setDataPaging({
                    ...dataPaging,
                    paging: {
                      ...dataPaging.paging,
                      orderBy:
                        Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                      orderByDesc:
                        Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                    },
                  });
                }
                return {
                  data: data,
                  success: marketingCampaignStore.baocaoQuaTangKH.isSuccess,
                };
              }
              return [];
            }}
            columnsState={{
              value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            toolBarRender={() => [
              <>
                {checkPermission('EXPORT') ? (
                  <CustomButton
                    size="middle"
                    loading={exportLoading}
                    className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                    type="primary"
                    onClick={async () => {
                      setExportLoading(true);
                      await marketingCampaignPresenter.exportReport({ ...dataPaging, lang: uiStore.language });
                      setExportLoading(false);
                    }}
                  >
                    <AiOutlineDownload className="block text-base" />
                    <span className="block">{t('btn.export')}</span>
                  </CustomButton>
                ) : (
                  ''
                )}
              </>,
              // nút lưu mẫu bc
              <SaveReportForm
                setIsResizablePresent={setIsResizablePresent}
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
                templateReportModalProps={templateReportModalProps}
              />,
            ]}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          className="lg:!w-[50%]"
          onClose={onClose}
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              onClick={() => {
                setIsSearch(true);

                const thoiDiemTT = form.getFieldValue('pickDate');

                let fromTime = undefined;
                let toTime = undefined;
                if (thoiDiemTT) {
                  fromTime = thoiDiemTT[0].format('YYYY-MM-DD') || undefined;
                  toTime = thoiDiemTT[1].format('YYYY-MM-DD') || undefined;
                }
                setDataPaging({
                  ...dataPaging,
                  ...form.getFieldsValue(),
                  fromTime: fromTime,
                  toTime: toTime,
                  paging: { ...dataPaging.paging, pageIndex: 1 },
                });
                form.submit();
                // tableRef.current?.reload();
              }}
              className="my-auto ml-auto"
              type="primary"
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={() => {
              tableRef.current?.reload();
            }}
          >
            {/* Khách hàng */}
            <SearchItem name={'customerList'} label={t('marketing.khach-hang')}>
              <CustomSelect
                mode="multiple"
                options={listCustomer}
                allowClear
                showSearch
                filterOption={false}
                onSearch={(value) => {
                  searchCustomer(value);
                }}
                fieldNames={{ label: 'value', value: 'key' }}
              />
            </SearchItem>
            {/* Nhân viên kinh doanh */}
            <SearchItem name={'personInCharge'} label={t('search-form.business-man')}>
              <CustomSelect
                options={listPersonInCharge}
                allowClear
                showSearch
                filterOption={false}
                onSearch={(value) => {
                  searchPersonInCharge(value, 'NVKD');
                }}
                fieldNames={{ label: 'value', value: 'key' }}
              />
            </SearchItem>
            {/*  NV ADmin */}
            <SearchItem name={'adminEmployee'} label={t('marketing.nv-admin')}>
              <CustomSelect
                options={listNVAdmin}
                allowClear
                showSearch
                filterOption={false}
                onSearch={(value) => {
                  searchPersonInCharge(value, 'NVADMIN');
                }}
                fieldNames={{ label: 'value', value: 'key' }}
              />
            </SearchItem>
            {/* Phòng ban */}
            <SearchItem name={'department'} label={t('marketing.phong-ban')}>
              <CustomSelect
                options={listDepartment}
                filterOption={false}
                fieldNames={{ label: 'value', value: 'key' }}
                onSearch={(value) => {
                  searchDepartment(value);
                }}
                onClear={() => searchDepartment()}
                showSearch
                allowClear
              />
            </SearchItem>
            {/* Loại tài trợ*/}
            <SearchItem name={'typeSpon'} label={t('marketing.loai')}>
              <CustomSelect fieldNames={{ label: 'value', value: 'key' }} options={sponsType} allowClear />
            </SearchItem>
            {/* Khu vực */}
            <SearchItem name={'saleOfficeCode'} label={t('search-form.area')}>
              <CustomSelect
                options={listRegion}
                onChange={async (value, option) => {
                  await getListTinhThanhPho(option?.key);
                  if (!option) {
                    setListQuanHuyen([])
                    form.setFieldsValue({ provinceId: undefined, districtId: undefined })
                  }
                }}
                filterOption={false}
                fieldNames={{ label: 'value', value: 'key' }}
                allowClear
              />
            </SearchItem>
            {/* Tỉnh/Thành phố */}
            <SearchItem name={'provinceId'} label={t('search-form.province')}>
              <CustomSelect
                mode="multiple"
                options={listTinh}
                onChange={async (value, option) => {
                  if (option.length) {
                    await getListQuanHuyen(option.map((i: any) => i.key));
                  } else {
                    setListQuanHuyen([])
                    form.setFieldValue('districtId', undefined)
                  }
                }}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                allowClear
              />
            </SearchItem>
            {/* Quận / Huyện */}
            <SearchItem name={'districtId'} label={t('search-form.district')}>
              <CustomSelect
                mode="multiple"
                options={listQuanHuyen}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                allowClear
              />
            </SearchItem>

            {/* Thời gian (common)*/}
            <SearchItem name={'commonDate'} label={t('marketing.thoi-diem')}>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: 'value', value: 'key' }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisabledPickDate(option.key === 'Custom' ? false : true);
                    await getDateByKey(option.key);
                  } else {
                    form.setFieldValue('pickDate', undefined);
                    setDisabledPickDate(false);
                  }
                }}
                allowClear
              />
            </SearchItem>
            {/*  Thời gian  (từ ngày -> đến ngày) */}
            <SearchItem name={'pickDate'} col2>
              <RangePicker disabled={disabledPickDate} format="DD/MM/YYYY" className="w-full" />
            </SearchItem>
          </SearchForm>
        </SearchBox>
      </PageWrapper>
    );
  });
};

export default createPresentReport;
